export class Spin {
    value: number
}